import type { FC } from 'react';
import React from 'react';
import { Image } from '@edreamsodigeo/prisma-design-system';

import type { CarrierLogoProps } from './types';

const images = {
  MA: '/images/mobile/airline_logos/MA.png',
  MIX: '/images/onefront/airlines/smVIN2.gif',
};
export const CarrierLogo: FC<CarrierLogoProps> = ({
  id,
  name,
  imageSize,
  borderColor = 'neutral.80',
  bordered = true,
}) => {
  const src = images[id] ?? `/images/onefront/airlines/sm${id}.gif`;
  return (
    <Image
      src={src}
      alt={name}
      size={imageSize}
      rounded
      borderColor={borderColor}
      bordered={bordered}
    />
  );
};
